import React, { useMemo } from 'react';
import type { PostClientSignup } from '@lt/api/dist/methods/client/types';
import { isEmpty } from 'lodash';
import { useTranslation } from '@lt/localization';
import type { FormValues } from './types';
import { Title } from '../Title';
import type {
  QueryParams,
  RequestStatus,
  SetSharedState,
  SharedState,
} from '../../types';
import { Form, Content, Footer } from './components';

interface Props {
  email?: string;
  phone?: string;
  name?: string;
  surname?: string;
  id?: number;
  sharedState: SharedState;
  setSharedState: SetSharedState;
  isMobile?: boolean;
  onSubmit: (data: PostClientSignup) => Promise<void>;
  requestStatus: RequestStatus;
  backToLoginForm?: () => void;
  queryParams?: QueryParams;
  isStyleAsMobile?: boolean;
}

export const RegistrationForm: React.FC<Props> = ({
  name,
  surname,
  email,
  phone,
  id,
  sharedState,
  setSharedState,
  isMobile,
  onSubmit,
  requestStatus,
  backToLoginForm,
  queryParams,
  isStyleAsMobile,
}) => {
  const { t } = useTranslation();
  const initialValues: FormValues = useMemo(
    () => ({
      id: id ?? undefined,
      name: name ?? '',
      surname: surname ?? '',
      email: email ?? '',
      phone: phone ?? '',
      acceptProcessingPersonalData: false,
      acceptPromotions: false,
    }),
    [id, name, surname, email, phone],
  );

  return (
    <Form
      isMobile={isMobile}
      requestStatus={requestStatus}
      initialValues={initialValues}
      onSubmit={onSubmit}
      queryParams={queryParams}
      HeaderComponent={() => (
        <Title>{t('checkout.registrationForm.title')}</Title>
      )}
      ContentComponent={(props) => (
        <Content
          backToLoginForm={backToLoginForm}
          setSharedState={setSharedState}
          sharedState={sharedState}
          disablePhone={!isEmpty(initialValues.phone)}
          disableEmail={!isEmpty(initialValues.email)}
          isStyleAsMobile={isStyleAsMobile}
          {...props}
        />
      )}
      FooterComponent={Footer}
    />
  );
};
